import { Injectable, inject } from '@angular/core';
import { CanActivateFn, Router, UrlTree } from '@angular/router';
import { AuthStore } from '@app/core/auth/stores/auth-store';
import { ToastService } from '@app/core/services/toast.service';

// Standalone guard function (Angular 15+)
// Note: Uses lazy injection to avoid circular dependency during app initialization
export const authGuard: CanActivateFn = (route, state) => {
  let authStore: AuthStore;
  let router: Router;
  let toast: ToastService;

  try {
    authStore = inject(AuthStore);
    router = inject(Router);
    toast = inject(ToastService);
  } catch (error) {
    // If injection fails during initialization, redirect to login
    const fallbackRouter = inject(Router);
    return fallbackRouter.createUrlTree(['/login'], {
      queryParams: { returnUrl: state.url }
    });
  }

  const authState = authStore.authState();

  // Check if user is authenticated
  if (authState === 'authenticated') {
    return true;
  }

  // If session is locked, redirect to locked page
  if (authState === 'locked') {
    return router.createUrlTree(['/locked'], {
      queryParams: { returnUrl: state.url }
    });
  }

  // If not logged in, show toast and redirect to login
  toast.showSessionExpired();
  return router.createUrlTree(['/login'], {
    queryParams: { returnUrl: state.url }
  });
};
